import React from 'react';

import { ElementProps, withProps } from '../../entity/components';
import { FlexBox } from '../containers/FlexBox';

export type BadgeProps = ElementProps & {
  children: React.ReactNode;
};

export const Badge: React.FC<BadgeProps> = (props) => {
  const sx = {
    display: 'inline',
    alignItems: 'center',
    borderRadius: '9999px',
    color: 'white',
    fontWeight: 'bold',
    padding: '4px 12px 2px 12px',
    width: '112px',
    fontSize: '0.875rem',
    ...props.sx,
  };
  return <FlexBox {...withProps({ ...props, sx })}>{props.children}</FlexBox>;
};
